"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ServerContextScript_exports = {};
__export(ServerContextScript_exports, {
  ServerContextScript: () => ServerContextScript
});
module.exports = __toCommonJS(ServerContextScript_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_constants = require("../constants");
var import_htmlEscape = require("../utils/htmlEscape");
var import_constants2 = require("../vite/constants");
var import_one_server_only = require("../vite/one-server-only");
function ServerContextScript() {
  if (process.env.VITE_ENVIRONMENT === "client") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("script", {
      async: true,
      // @ts-expect-error
      href: import_constants.SERVER_CONTEXT_KEY,
      suppressHydrationWarning: true,
      dangerouslySetInnerHTML: {
        __html: ``
      }
    });
  }
  if (process.env.VITE_ENVIRONMENT === "ssr") {
    var _ref;
    var _restContext_matches, _restContext_matches1;
    var context = (0, import_one_server_only.useServerContext)();
    var cssUrls = (context === null || context === void 0 ? void 0 : context.css) || [];
    var { cssContents, ...restContext } = context || {};
    var hasLeafLoaderData = restContext.loaderData !== void 0;
    var lastMatchIndex = ((_ref = (_restContext_matches = restContext.matches) === null || _restContext_matches === void 0 ? void 0 : _restContext_matches.length) !== null && _ref !== void 0 ? _ref : 0) - 1;
    var compactMatches = (_restContext_matches1 = restContext.matches) === null || _restContext_matches1 === void 0 ? void 0 : _restContext_matches1.map(function(m, i) {
      return {
        routeId: m.routeId,
        pathname: m.pathname,
        params: m.params,
        ...hasLeafLoaderData && i === lastMatchIndex ? {} : {
          loaderData: m.loaderData
        }
      };
    });
    var clientContext = {
      ...restContext,
      matches: compactMatches,
      cssInlineCount: (cssContents === null || cssContents === void 0 ? void 0 : cssContents.length) || 0,
      // use placeholder — postRenderData is set during render (after this component)
      // and replaced in the HTML string after rendering completes
      postRenderData: import_constants2.SERVER_CONTEXT_POST_RENDER_STRING
    };
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("script", {
      async: true,
      // @ts-expect-error
      href: import_constants.SERVER_CONTEXT_KEY,
      suppressHydrationWarning: true,
      dangerouslySetInnerHTML: {
        __html: `
              globalThis["${import_constants.SERVER_CONTEXT_KEY}"] = ${(0, import_htmlEscape.safeJsonStringify)(clientContext)};
              globalThis.__oneLoadedCSS = new Set(${(0, import_htmlEscape.safeJsonStringify)(cssUrls)});
          `
      }
    });
  }
  return null;
}
//# sourceMappingURL=ServerContextScript.js.map
